import { OTHER } from '@rsos/constants/alertEmergencyTypes';
import {
  BE_CALL_ALERTING,
  BE_CALL_ANSWERED,
  BE_END_CALL,
  BE_HOLD_CALL,
  BE_RETRIEVE_CALL,
} from '@rsos/constants/callStatuses';
import { ALERTS, EMERGENCY_CALLS } from '@rsos/constants/incidentTypes';
import { SOURCE_SMS } from '@rsos/constants/locationSources';
import { LANDLINE, VOIP } from '@rsos/constants/locationTypes';
import getMostRecentCallStatus from '@rsos/utils/getMostRecentCallStatus';
import AlertActiveAssailantSelected from '../assets/alert_active_assailant_selected.svg';
import AlertSelected from '../assets/alert_selected.svg';
import AlertTestSelected from '../assets/alert_test_selected.svg';
import AlertTrainSelected from '../assets/alert_train_selected.svg';
import AllAlert from '../assets/allalerts.svg';
import AllAlertActiveAssailant from '../assets/allalerts_active_assailant.svg';
import AllAlertTest from '../assets/allalerts_test.svg';
import AllAlertTrain from '../assets/allalerts_train.svg';
import AllCallMarker from '../assets/allcall_marker.svg';
import AllCallSMS from '../assets/allcall_textto911.svg';
import CallLandline from '../assets/call_landline.svg';
import CallSelected from '../assets/call_selected.svg';
import CallVOIP from '../assets/call_voip.svg';
import CallStatusAnswered from '../assets/calls/call_status_answered.svg';
import CallStatusOnHold from '../assets/calls/call_status_on_hold.svg';
import CallStatusReleased from '../assets/calls/call_status_released.svg';
import CallStatusRinging from '../assets/calls/call_status_ringing.svg';
import HistoricAlertMarker from '../assets/historic_alert_marker.svg';
import HistoricCallMarker from '../assets/historic_call_marker.svg';
import SMSSelected from '../assets/sms_selected.svg';

interface Incident {
  source?: string;
  isTT911?: boolean;
  caller_id?: string;
  class_of_service_category?: string;
}

interface GetIconsUrl {
  incident: Incident;
  incidentIdx: number;
  incidentType: string;
  isAllView: boolean;
  mostRecentIncidentIdx?: number;
  isUnacceptedActiveAssailant?: boolean;
  isUnacceptedTrainIncident?: boolean;
  filteredCalls?: unknown[];
  hasCallStatus?: boolean;
  isTestAlert?: boolean;
}

/**
 * Determine icon type based on incident, index, and various properties
 */
export const getIconsUrl = ({
  incident,
  incidentIdx,
  incidentType,
  isAllView,
  mostRecentIncidentIdx,
  isUnacceptedActiveAssailant,
  isUnacceptedTrainIncident,
  filteredCalls,
  hasCallStatus,
  isTestAlert,
}: GetIconsUrl) => {
  if (incidentType === ALERTS) {
    if (isAllView) {
      if (isUnacceptedActiveAssailant) {
        return AllAlertActiveAssailant;
      } else if (isUnacceptedTrainIncident) {
        return AllAlertTrain;
      } else if (isTestAlert) {
        return AllAlertTest;
      }
      return AllAlert;
    } else {
      if (incidentIdx > 0) {
        return HistoricAlertMarker;
      } else {
        if (isTestAlert) {
          return AlertTestSelected;
        }
        if (isUnacceptedActiveAssailant) {
          return AlertActiveAssailantSelected;
        } else if (isUnacceptedTrainIncident) {
          return AlertTrainSelected;
        }
        return AlertSelected;
      }
    }
  } else if (incidentType === EMERGENCY_CALLS) {
    if (isAllView) {
      if (incident?.source === SOURCE_SMS || incident?.isTT911) {
        return AllCallSMS;
      } else {
        if (hasCallStatus) {
          const callStatus = getMostRecentCallStatus({
            callerID: incident?.caller_id,
            callQueue: filteredCalls,
            hasAniAliAccess: true,
            hasCallStatusAccess: true,
          });

          if (callStatus) {
            if (
              callStatus === BE_CALL_ANSWERED ||
              callStatus === BE_RETRIEVE_CALL
            ) {
              return CallStatusAnswered;
            } else if (callStatus === BE_HOLD_CALL) {
              return CallStatusOnHold;
            } else if (callStatus === BE_END_CALL) {
              return CallStatusReleased;
            } else if (callStatus === BE_CALL_ALERTING) {
              return CallStatusRinging;
            }
          }
        }
        return AllCallMarker;
      }
    } else {
      if (mostRecentIncidentIdx && incidentIdx < mostRecentIncidentIdx) {
        return HistoricCallMarker;
      } else if (incident?.source === SOURCE_SMS || incident?.isTT911) {
        return SMSSelected;
      } else {
        const classOfServiceCategory = incident?.class_of_service_category;
        if (classOfServiceCategory === VOIP) {
          return CallVOIP;
        } else if (
          classOfServiceCategory === LANDLINE ||
          classOfServiceCategory === OTHER
        ) {
          return CallLandline; // return CallLandline icon for both LANDLINE and OTHER
        }
        return CallSelected;
      }
    }
  } else {
    return null;
  }
};
